/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';

/**
 * Logger utility that chooses between console.log and datadogLogs based on environment.
 * In production, logs are sent to Datadog. In other environments, logs are sent to console.
 * Uses the same interface as Datadog Logger for consistency.
 */
export const logger = {
  /**
   * Logs an info message
   */
  info: (message: string, messageContext?: object) => {
    if (import.meta.env.VITE_ENV === 'production') {
      datadogLogs.logger.info(message, messageContext);
    } else {
      console.log(message, messageContext || '');
    }
  },

  /**
   * Logs an error message
   */
  error: (message: string, messageContext?: object, error?: Error) => {
    if (import.meta.env.VITE_ENV === 'production') {
      datadogLogs.logger.error(message, messageContext, error);
    } else {
      console.error(message, messageContext || '', error || '');
    }
  },

  /**
   * Logs a warning message
   */
  warn: (message: string, messageContext?: object) => {
    if (import.meta.env.VITE_ENV === 'production') {
      datadogLogs.logger.warn(message, messageContext);
    } else {
      console.warn(message, messageContext || '');
    }
  },

  /**
   * Logs a debug message
   */
  debug: (message: string, messageContext?: object) => {
    if (import.meta.env.VITE_ENV === 'production') {
      datadogLogs.logger.debug(message, messageContext);
    } else {
      console.debug(message, messageContext || '');
    }
  },
};
